module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Buttons"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Buttons")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Basic")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-button', [_vm._v("Default Button")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary Button")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    }
  }, [_vm._v("Text Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Disabled Button")]), _vm._v(" "), _c('p', [_vm._v("The disableds attribute determines if the button is disabled.")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true,
      "disabled": true
    }
  }, [_vm._v("Default Button")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": ""
    }
  }, [_vm._v("Primary Button")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "disabled": ""
    }
  }, [_vm._v("Text Button")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Color Indication")]), _vm._v(" "), _c('p', [_vm._v("Different colors represent different meanings.")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true,
      "type": "success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true,
      "type": "warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true,
      "type": "danger"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Icon Button")]), _vm._v(" "), _c('p', [_vm._v("Use icons to add more meaning to Button. You can use icon alone to save some space, or with text together.")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "edit"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn-rounded",
    attrs: {
      "type": "primary",
      "icon": "share"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Upload "), _c('i', {
    staticClass: "el-icon-upload el-icon-right"
  })])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e6ae195!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/Buttons.vue
// module id = 1298
// module chunks = 2